import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../../utils/images";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  cleanTerritories,
  fetchCountries,
  fetchTerritories,
  pushNotification,
} from "../../actions/index";
import Selector2 from "../Selector2";

function DirectorsAndOwners(props) {
  const { t, classes, countries, territories } = props;
  const [directorsArr, setDirectorsArr] = useState([]);
  const [directorFirstName, setDirectorFirstName] = useState("");
  const [directorLastName, setDirectorLastName] = useState("");
  const [directorPosition, setDirectorPosition] = useState("");
  const [directorAddress, setDirectorAddress] = useState("");
  const [directorCountry, setDirectorCountry] = useState("");
  const [directorCity, setDirectorCity] = useState("");
  const [directorState, setDirectorState] = useState("");
  const [directorZipcode, setDirectorZipcode] = useState("");

  const [countriesArr, setCountries] = useState([]);
  const [territoriesArr, setTerritories] = useState([]);

  const [missingFields, setMissingFields] = useState([]);

  useEffect(() => {
    if (countries) {
      let arr = [];

      countries.map((c) => {
        arr.push(c.name);
      });

      setCountries([...arr]);
    } else {
      props.fetchCountries();
    }
  }, [countries]);

  useEffect(() => {
    if (directorCountry) {
      let countryFound = countries.find((c) => c.name === directorCountry);

      props.fetchTerritories({ code: countryFound.alpha2 });
    }
  }, [directorCountry]);

  useEffect(() => {
    if (territories) {
      setTerritories([...territories]);
    }
  }, [territories]);

  const directorsInputs = [
    {
      id: "first_name",
      label: "_firstName",
      value: directorFirstName,
      modifier: setDirectorFirstName,
    },
    {
      id: "last_name",
      label: "_lastName",
      value: directorLastName,
      modifier: setDirectorLastName,
    },
    {
      id: "position",
      label: "_position",
      value: directorPosition,
      modifier: setDirectorPosition,
    },
    {
      id: "address_line_1",
      label: "_address",
      value: directorAddress,
      modifier: setDirectorAddress,
    },
    {
      id: "country",
      label: "_country",
      type: "selector",
      options: countriesArr,
      value: directorCountry,
      modifier: setDirectorCountry,
      placeholder: "_country",
    },
    {
      id: "city",
      label: "_city",
      value: directorCity,
      modifier: setDirectorCity,
    },
    {
      id: "territory",
      label: "_state",
      type: "selector",
      options: territoriesArr,
      value: directorState,
      modifier: setDirectorState,
      placeholder: "_territory",
    },
    {
      id: "postcode",
      label: "_zipcode",
      value: directorZipcode,
      modifier: setDirectorZipcode,
    },
  ];

  const addDirector = () => {
    let countryFound = countries.find((c) => c.name === directorCountry);
    let newDirector = {
      type: props.owners ? "beneficial_owner" : "director",
      first_name: directorFirstName,
      last_name: directorLastName,
      position: directorPosition,
      address_line_1: directorAddress,
      country: countryFound ? countryFound.alpha2 : "",
      city: directorCity,
      territory: directorState,
      postcode: directorZipcode,
    };

    setMissingFields([]);

    let missing_fields = [];

    Object.entries(newDirector).map((entry) => {
      if (entry[1] === "") {
        missing_fields.push(entry[0]);
      }
    });

    if (missing_fields.length) {
      props.pushNotification({ message: "missingFields", type: "error" });
      setMissingFields([...missing_fields]);
      return;
    }

    newDirector.id = directorsArr.length + 1;
    setDirectorsArr([...directorsArr, newDirector]);
    cleanDirectorForm();
  };

  const cleanDirectorForm = () => {
    setDirectorFirstName("");
    setDirectorLastName("");
    setDirectorPosition("");
    setDirectorState("");
    setDirectorZipcode("");
    setDirectorAddress("");
    setDirectorCity("");
    setDirectorCountry("");
    props.cleanTerritories();
  };
  const removeDirector = (directorID) => {
    let dirs = directorsArr.filter((d) => d.id !== directorID);
    setDirectorsArr([...dirs]);
  };
  const validateDataAndProceed = async () => {
    directorsArr.map((d) => delete d.id);

    await props.setDirectors(directorsArr);
    if (props.owners) {
      await props.trigger(true);
    } else {
      await props.moveForward();
    }
  };

  return (
    <div className={`corporateStepContainer ${classes.directorsContainer}`}>
      <h2
        dangerouslySetInnerHTML={{
          __html: props.owners ? t("_corporateT6") : t("_corporateT5"),
        }}
      />
      <p>{props.owners ? t("_corporateP3") : t("_corporateP2")}</p>
      <div className={`inputsContainer ${classes.inputRows}`}>
        <div className="left">
          <p className="label">
            {props.owners ? t("_ownerDetails") : t("_directorsDetails")}
          </p>
          <div className="inputsWrapper">
            {directorsInputs.map((i, idx) => {
              if (i.type && i.type === "selector") {
                return (
                  <Selector2
                    key={idx}
                    selectedOption={i.value}
                    selectorHandle={i.modifier}
                    options={i.options}
                    disabled={i.options.length ? false : true}
                    placeholder={t(i.placeholder)}
                    width="100%"
                    invalid={missingFields.includes(i.id) ? true : false}
                  />
                );
              }
              return (
                <input
                  type="text"
                  key={idx}
                  placeholder={t(i.label)}
                  onChange={(e) => i.modifier(e.target.value)}
                  value={i.value}
                  className={missingFields.includes(i.id) ? "invalidField" : ""}
                />
              );
            })}
          </div>
          {directorsArr.length === 5 ? (
            ""
          ) : (
            <button className="addBtn" onClick={(e) => addDirector()}>
              {t("_add")}
            </button>
          )}
        </div>
        <div className="right">
          {directorsArr.length ? (
            <div className="directorsAddedWrapper">
              {directorsArr.map((d, idx) => {
                return (
                  <div className="directorSingleAdded" key={idx}>
                    <span>{idx + 1}</span>
                    <button onClick={() => removeDirector(d.id)}>
                      {t("_remove")}
                    </button>
                    <div>
                      <p>
                        {d.last_name}, {d.first_name}
                      </p>
                      <p>{d.position}</p>
                      <p>{d.country}</p>
                      <p>{d.address}</p>
                      <p>
                        {d.territory}, {d.postcode}
                      </p>

                      {/* {Object.entries(d).map((f, idx) => {
                        if (f[0] !== "id") {
                          return (
                            <p>
                              {t(f[0])}: <b>{f[1]}</b>
                            </p>
                          );
                        }
                      })} */}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <img
              src={
                props.owners
                  ? images.illustrations.corpSolo6
                  : images.illustrations.corpSolo5
              }
            />
          )}
        </div>
      </div>

      <div className="nextButtonContainer">
        <button
          disabled={directorsArr.length === 0 ? true : false}
          onClick={() => validateDataAndProceed()}
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    countries: state.countries,
    territories: state.territories,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCountries,
      fetchTerritories,
      pushNotification,
      cleanTerritories,
    },
    dispatch
  );
}

const styles = (theme) => ({
  directorsContainer: {
    "& .directorsAddedWrapper": {
      width: "100%",
      "& .directorSingleAdded": {
        position: "relative",
        width: "100%",
        height: "auto",
        marginTop: 32,
        padding: 8,
        borderRadius: 2,
        background: theme.colors.misc.blue,
        display: "flex",
        [theme.breakpoints.down(650)]: {
          width: "100%",
        },
        "& span": {
          fontSize: 18,
          color: theme.colors.misc.blue,
          background: theme.colors.background.fore,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 24,
          height: 24,
          marginRight: 8,
        },
        "& p": {
          color: `${theme.colors.text.textOnRed} !important`,
        },

        "& button": {
          color: theme.colors.buttons.sell,
          border: "none",
          background: "none",
          fontSize: 14,
          fontWeight: 600,
          position: "absolute",
          bottom: 0,
          right: 0,
          transform: "translateY(110%)",
        },
      },
    },
  },
  inputRows: {
    "& .label": {
      display: "flex",
      justifyContent: "space-between",
      "& button": {
        background: "none",
        border: "none",
        color: theme.colors.buttons.sell,
        fontWeight: 600,
      },
    },
    "& .inputsWrapper": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      width: "100%",
      "& input": {
        ...theme.defaults.input,
        maxWidth: "none",
        marginBottom: 8,
        marginTop: 8,
        width: "100%",
        "&:first-of-type, &:nth-of-type(2)": {
          width: "49%",
          marginBottom: 0,
        },
        "&:nth-of-type(3)": {
          marginBottom: 0,
        },
        "&.invalidField": {
          borderColor: theme.colors.buttons.sell,
        },
      },
    },

    "& .addBtn": {
      ...theme.defaults.roundBtn,
      marginTop: 24,
      background: theme.colors.buttons.green,
    },
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(DirectorsAndOwners)
  )
);
